var _g, _path, _path2, _g2, _path3, _path4, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 834,
    height: 467,
    viewBox: "0 0 834 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0624 174.254C54.0624 170.404 50.9392 167.284 47.0866 167.284C43.234 167.284 40.1108 170.404 40.1108 174.254V271.836C40.1108 275.685 43.234 278.806 47.0866 278.806C50.9392 278.806 54.0624 275.685 54.0624 271.836V174.254Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9657 146.373C81.9657 142.524 78.8426 139.403 74.9899 139.403C71.1373 139.403 68.0142 142.524 68.0142 146.373V299.717C68.0142 303.566 71.1373 306.687 74.9899 306.687C78.8426 306.687 81.9657 303.566 81.9657 299.717V146.373Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.869 188.194C109.869 184.345 106.745 181.224 102.893 181.224C99.0402 181.224 95.917 184.345 95.917 188.194V257.896C95.917 261.745 99.0402 264.866 102.893 264.866C106.745 264.866 109.869 261.745 109.869 257.896V188.194Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.772 160.313C137.772 156.464 134.649 153.343 130.796 153.343C126.943 153.343 123.82 156.464 123.82 160.313V285.776C123.82 289.626 126.943 292.746 130.796 292.746C134.649 292.746 137.772 289.626 137.772 285.776V160.313Z",
    fill: "#4285F4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640.028 223.045C640.028 99.8605 540.087 0 416.803 0C293.519 0 193.578 99.8605 193.578 223.045C193.578 346.229 293.519 446.09 416.803 446.09C540.087 446.09 640.028 346.229 640.028 223.045Z",
    fill: "#4285F4",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M584.222 223.045C584.222 130.657 509.266 55.7612 416.803 55.7612C324.34 55.7612 249.384 130.657 249.384 223.045C249.384 315.433 324.34 390.328 416.803 390.328C509.266 390.328 584.222 315.433 584.222 223.045Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_57_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.222 223.045C584.222 130.657 509.266 55.7612 416.803 55.7612C324.34 55.7612 249.384 130.657 249.384 223.045C249.384 315.433 324.34 390.328 416.803 390.328C509.266 390.328 584.222 315.433 584.222 223.045Z",
    fill: "white",
    fillOpacity: 0.01
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M504.513 113.169L510.327 130.595L527.766 136.403L510.327 142.212L504.513 159.637L498.698 142.212L481.259 136.403L498.698 130.595L504.513 113.169Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.069 275.351L338.429 288.42L351.509 292.776L338.429 297.132L334.069 310.201L329.709 297.132L316.63 292.776L329.709 288.42L334.069 275.351Z",
    fill: "#4285F4",
    fillOpacity: 0.72
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.786 160.313C709.786 156.464 706.663 153.343 702.81 153.343C698.958 153.343 695.834 156.464 695.834 160.313V285.776C695.834 289.626 698.958 292.746 702.81 292.746C706.663 292.746 709.786 289.626 709.786 285.776V160.313Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.689 188.194C737.689 184.345 734.566 181.224 730.714 181.224C726.861 181.224 723.738 184.345 723.738 188.194V257.896C723.738 261.745 726.861 264.866 730.714 264.866C734.566 264.866 737.689 261.745 737.689 257.896V188.194Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.592 146.373C765.592 142.524 762.469 139.403 758.616 139.403C754.764 139.403 751.641 142.524 751.641 146.373V299.717C751.641 303.566 754.764 306.687 758.616 306.687C762.469 306.687 765.592 303.566 765.592 299.717V146.373Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.496 174.254C793.496 170.404 790.372 167.284 786.52 167.284C782.667 167.284 779.544 170.404 779.544 174.254V271.836C779.544 275.685 782.667 278.806 786.52 278.806C790.372 278.806 793.496 275.685 793.496 271.836V174.254Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_57_146",
    x: 234.384,
    y: 50.7612,
    width: 364.838,
    height: 364.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57_146"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_57_146",
    result: "effect2_dropShadow_57_146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_57_146",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImage);
export default __webpack_public_path__ + "static/media/searchImage.6de87b26296695a4f30e7e4894d105f2.svg";
export { ForwardRef as ReactComponent };